const NotificationService = require('ceres/app/services/NotificationService');

import ValidationService from '../../../services/ValidationServiceLegacy';
import TranslationService from 'ceres/app/services/TranslationService';

Vue.component('checkout-create-update-address', {

    delimiters: ['${', '}'],

    props: [
        'editType',
        'addressType',
        'template'
    ],

    data() {
        return {
            waiting: false,
            addressFormNames:
                {
                    1: '#billing_address_form',
                    2: '#delivery_address_form'
                },
            addressData: {}
        };
    },

    computed: {

        addressList() {
            this.$store.getters.getAddressList(this.addressType);
        },

        ...Vuex.mapState({
            addressToEdit: state => state.address.addressToEdit
        })
    },


    created() {
        this.$options.template = this.template;
    },


    methods: {

        validate() {

            ValidationService
                .validateAddress($(this.addressFormNames[this.addressType]))
                .done(() => {
                    this.saveAddress();
                })
                .fail(invalidFields => {

                    const fieldNames = [];

                    for (const field of invalidFields) {

                        let fieldName = $(field).find('label').html();
                        fieldName = fieldName.slice(-1) === '*' ? fieldName.slice(0, fieldName.length - 1) : fieldName;

                        fieldNames.push(fieldName);
                    }

                    ValidationService.markInvalidFields(invalidFields, 'error');

                    //this.$refs.addressInputGroupCustom.hideAutocomplete();

                    NotificationService.error(
                        TranslationService.translate('Ceres::Template.checkoutCheckAddressFormFields', {fields: fieldNames.join(', ')})
                    );
                });
        },


        saveAddress() {

            this.addressData = this.addressToEdit[this.addressType];

            if (this.editType === 'initial' || this.editType === 'create') {
                this.createAddress();
            } else if (this.editType === 'update') {
                this.updateAddress();
            }
        },
        updateAddress() {

            this.waiting = true;
            this._syncOptionTypesAddressData();

            this.$store.dispatch('updateAddress', {address: this.addressData, addressType: this.addressType})
                .then(resolve => {
                        this.waiting = false;
                    }, error => {
                        this.waiting = false;

                        if (error.validation_errors) {
                            this._handleValidationErrors(error.validation_errors);
                        }
                    }
                );
        },
        createAddress() {

            this.waiting = true;
            this._syncOptionTypesAddressData();

            this.$store.dispatch('createAddress', {address: this.addressData, addressType: this.addressType})
                .then(response => {
                        this.waiting = false;
                    }, error => {
                        this.waiting = false;

                        if (error.validation_errors) {
                            this._handleValidationErrors(error.validation_errors);
                        }
                    }
                );
        },
        _handleValidationErrors(validationErrors) {

            ValidationService.markFailedValidationFields($(this.addressFormNames[this.addressType]), validationErrors);

            let errorMessage = '';

            for (const value of Object.values(validationErrors)) {
                errorMessage += value + '<br>';
            }

            NotificationService.error(errorMessage);
        },
        _syncOptionTypesAddressData() {

            if (typeof this.addressData.options !== 'undefined') {
                for (const optionType of this.addressData.options) {

                    switch (optionType.typeId) {

                        case 1: {
                            if (this.addressData.vatNumber && this.addressData.vatNumber !== optionType.value) {
                                optionType.value = this.addressData.vatNumber;
                            }

                            break;
                        }
                        case 9: {
                            if (this.addressData.birthday && this.addressData.birthday !== optionType.value) {
                                optionType.value = this.addressData.birthday;
                            }
                            break;
                        }
                        case 11: {
                            if (this.addressData.title && this.addressData.title !== optionType.value) {
                                optionType.value = this.addressData.title;
                            }
                            break;
                        }
                        case 4: {
                            if (this.addressData.telephone && this.addressData.telephone !== optionType.value) {
                                optionType.value = this.addressData.telephone;
                            }
                            break;
                        }
                    }
                }
            }
        }
    }
});
